export default "https://sdk.cotreat.ai/flags-ae531914.png";